import { useCallback, useMemo } from 'react';
/**
 * Hook that forwards wheel events from an element to a target scroll container.
 *
 * This is useful when dealing with `overflow-clip` ancestors that block scroll
 * propagation. The hook intercepts wheel events and manually forwards them to
 * the target scroll container.
 *
 * @example
 * ```tsx
 * const scrollContainerRef = useRef<HTMLDivElement>(null);
 * const { onWheel } = useScrollForwarding({ scrollContainerRef });
 *
 * <Popover onWheelContent={onWheel}>
 *   <HoverCard>Content</HoverCard>
 * </Popover>
 * ```
 */
export function useScrollForwarding(options = {}) {
    const { scrollContainerRef, enabled = true } = options;
    const handleWheel = useCallback((params) => {
        if (!enabled)
            return;
        const scrollContainer = scrollContainerRef?.current;
        if (!scrollContainer)
            return;
        // Forward the scroll to the main container
        scrollContainer.scrollBy({
            top: params.deltaY,
            left: params.deltaX,
            behavior: 'instant',
        });
    }, [scrollContainerRef, enabled]);
    return useMemo(() => ({
        onWheel: handleWheel,
    }), [handleWheel]);
}
//# sourceMappingURL=useScrollForwarding.js.map